module.exports = __webpack_public_path__ + "img/9.2ee6020e.jpg";